import InviteToMoveInConfirmationModal from './InviteToMoveInConfirmationModal';
export default InviteToMoveInConfirmationModal;
